import {
  zapOperationsToolsAtom,
  zapOperationsRecipe,
} from "./zapOperations/zapOperations";
import {
  tablesOperationsToolsAtom,
  tablesOperationsRecipe,
} from "./tablesOperations/tablesOperations";
import {
  ZapOperations,
  FormsSetup,
  TablesOperations,
  rawRecipeData,
} from "./recipe_definitions_raw";
import { formsSetupToolsAtom, formsSetupRecipe } from "./formsSetup/formsSetup";

// Direct recipe selection - always use unified zap operations recipe
const getZapOperationsRecipe = () => {
  return {
    toolsAtom: zapOperationsToolsAtom,
    fullInstructions: zapOperationsRecipe,
  };
};

const getRecipeExtensions = () => ({
  [ZapOperations]: getZapOperationsRecipe(),
  [FormsSetup]: {
    toolsAtom: formsSetupToolsAtom,
    fullInstructions: formsSetupRecipe,
  },
  [TablesOperations]: {
    toolsAtom: tablesOperationsToolsAtom,
    fullInstructions: tablesOperationsRecipe,
  },
});

// Default export - always uses V2
export const recipeDefinitionsFull = rawRecipeData.map((recipe) => {
  const recipeExtensions = getRecipeExtensions();
  return {
    ...recipe,
    ...recipeExtensions[recipe.id],
  };
});

// Legacy export function - now uses unified zap operations recipe
export const getRecipeDefinitionsFull = () => {
  const recipeExtensions = getRecipeExtensions();
  return rawRecipeData.map((recipe) => {
    return {
      ...recipe,
      ...recipeExtensions[recipe.id],
    };
  });
};
